
import React from "react";
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight, Flag, Calculator } from "lucide-react";

interface TestNavigationProps {
  isLastQuestion: boolean;
  currentQuestionIndex: number;
  onPrevious: () => void;
  onNext: () => void;
  onSubmit: () => void;
  isSubmitting: boolean;
  isLocked?: boolean;
  
  // Additional props that might be passed from MockTest.tsx
  totalQuestions: number;
  currentIndex?: number;
  onNavigate?: (index: number) => void;
  answers?: Record<string, number>;
  flaggedQuestions?: Record<string, boolean>;
  onShowMathHints?: () => void;
  hasMathContent?: boolean;
}

const TestNavigation: React.FC<TestNavigationProps> = ({
  isLastQuestion,
  currentQuestionIndex,
  onPrevious,
  onNext,
  onSubmit,
  isSubmitting,
  isLocked = false,
  totalQuestions,
  currentIndex,
  onNavigate,
  answers,
  flaggedQuestions,
  onShowMathHints,
  hasMathContent = false
}) => {
  return (
    <div className="flex justify-between mt-6">
      <Button
        variant="outline"
        onClick={onPrevious}
        disabled={currentQuestionIndex === 0 || isSubmitting || isLocked}
      >
        <ChevronLeft className="h-4 w-4 mr-2" />
        Previous
      </Button>
      
      <div className="flex gap-2">
        {hasMathContent && onShowMathHints && (
          <Button
            variant="outline"
            onClick={onShowMathHints}
            className="bg-amber-50 text-amber-700 border-amber-200 hover:bg-amber-100"
          >
            <Calculator className="h-4 w-4 mr-2" />
            Math Tools
          </Button>
        )}
        
        {isLastQuestion ? (
          <Button
            variant="default"
            onClick={onSubmit}
            disabled={isSubmitting || isLocked}
            className="bg-green-600 hover:bg-green-700 text-white"
          >
            {isSubmitting ? "Submitting..." : "Submit Test"}
          </Button>
        ) : (
          <Button
            variant="default"
            onClick={onNext}
            disabled={isSubmitting || isLocked}
          >
            Next
            <ChevronRight className="h-4 w-4 ml-2" />
          </Button>
        )}
      </div>
    </div>
  );
};

export default React.memo(TestNavigation);
